const setRecommendProduct = (context, product) => {
  context.commit('SET_RECOMMEND_PRODUCT', product);
}

export default {
  setRecommendProduct
};



// WEBPACK FOOTER //
// ./src/store/modules/reserved/recommend/actions.js